export const colors = {
  darkBlue: '#131C4D',
  black: '#131C4D',
  lightGrey: '#CDCFDA',
  grey: '#898DA6',
  brandGrey: '#DCDDE4',
  button: {
    black: '#343434',
    blue: '#3652E0',
    red: '#E95353',
    chakraGrey: '#EDF2F7',
  },
  inputGrey:'#bdbfcd',
  lineGrey:'#EEEFF3',
}